if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement?.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const variantMediaData = JSON.parse(
          document.getElementById("VariantMediaData").textContent
        );
      
        // Get the current variant ID (you may need to adjust this based on your implementation)
        const currentVariantId = document.querySelector(
          'input[name="id"]'
        ).value;
      
        // Get the media IDs for the current variant
        const allowedMediaIds = variantMediaData[currentVariantId] || [];
      
        // Hide all media that are not in the allowedMediaIds
        document.querySelectorAll('.tp-thumb').forEach((element) => {
          let mediaId = element.querySelector('img')?.src.split('&')[0];
          mediaId = mediaId.replace(/^https:/, ''); // Remove protocol to match your media IDs

          const isAllowed = allowedMediaIds.some((media) => {
            if (typeof media === 'string') {
              console.log(media);
              return media === mediaId;
            } else if (typeof media === 'object' && media.preview_image) {
              return media.preview_image.src.replace(/^https:/, '') === mediaId;
            }
            return false;
          });
        
          if (!isAllowed && allowedMediaIds.length > 0) {
            element.classList.add("hidden"); // Hide non-matching media
          } else {
            element.classList.remove("hidden"); // Show matching media
          }
        });

          this.elements.viewer
          .querySelectorAll("li[data-media-id]").forEach((element) => {
          // Extract the mediaId and normalize it by removing query parameters
          let mediaId = element.querySelector('img')?.src.split('&')[0];
          mediaId = mediaId.replace(/^https:/, '');

          console.log('Normalized mediaId:', mediaId);
          console.log('Allowed Media IDs:', allowedMediaIds);

          const isAllowed = allowedMediaIds.some((media) => {
            if (typeof media === 'string') {
              console.log(media);
              return media === mediaId;
            } else if (typeof media === 'object' && media.preview_image) {
              return media.preview_image.src.replace(/^https:/, '') === mediaId;
            }
            return false;
          });
        
          if (!isAllowed && allowedMediaIds.length > 0) {
            element.classList.add('hidden'); // Add a hidden class to hide the media
          } else {
            element.classList.remove('hidden'); // Remove the hidden class to show the media
          }
        });
      
        // Set the active media
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]:not(.hidden)");
        if (!activeMedia) {
          return;
        }
      
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia?.classList?.add("is-active");
      
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);
      
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }
      
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
      
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: "smooth" });
        });
        this.playActiveMedia(activeMedia);
      
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail?.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
